import { useLocation } from "react-router-dom";
import { useI18n, langPrefix, LANGS, LANG_LABELS } from "../i18n";

/**
 * KO | EN | DE | FI 언어 토글.
 *
 * 언어는 BrowserRouter의 basename으로 부팅 때 한 번 정해지므로 SPA 내부 이동으로는
 * 바꿀 수 없다. 그래서 <Link>가 아니라 <a href>로 전체 로드를 일으킨다.
 *
 * useLocation().pathname 은 basename이 떨어진 경로라서, 대상 언어의 접두사만
 * 앞에 붙이면 같은 화면의 다른 언어 URL이 된다.
 */
function LangToggle({ className = "" }) {
    const { lang } = useI18n();
    const location = useLocation();

    const hrefFor = (target) => {
        const path = `${location.pathname}${location.search}${location.hash}`;
        // pathname이 "/"일 때 "/de/" 대신 "/de" 가 되도록 다듬는다.
        return `${langPrefix(target)}${path}`.replace(/\/+$/, "") || "/";
    };

    return (
        <div className={`lang_toggle ${className}`}>
            {LANGS.map((code, i) => (
                <span key={code} className="lang_item">
                    {i > 0 && <span className="lang_divider">|</span>}
                    <a
                        className={`lang_btn ${lang === code ? "active" : ""}`}
                        href={hrefFor(code)}
                        hrefLang={code}
                        aria-current={lang === code ? "true" : undefined}
                    >
                        {LANG_LABELS[code]}
                    </a>
                </span>
            ))}
        </div>
    );
}

export default LangToggle;
